import { IconBus16, IconWalk16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { ETransportType } from '../../../types/geo';

interface ITimeToGetProps {
  transportType: ETransportType;
  time: number;
}

export function UndergroundTimeToGet(props: ITimeToGetProps) {
  const { transportType, time } = props;
  const Icon = transportType === ETransportType.Walk ? IconWalk16 : IconBus16;

  return (
    <>
      <div className={styles['icon']}>
        <Icon fontSize={14} />
      </div>

      <span>{time} мин.</span>
    </>
  );
}
